function toggleHeight(element) {
    const isExpanded = element.getAttribute('data-faq-element') === 'expanded';
    if (isExpanded) {
        element.removeAttribute('data-faq-element');
    } else {
        element.setAttribute('data-faq-element', 'expanded');
    }
}
